﻿import jquery from 'jquery';

class AuditRepository {

    constructor() {
        this._urlAudit = '/hab_inmuebles/ajax/audit.asp';

    }

    auditarClic({ tipoAuditoria, codigoEmpresa, codigoOficina, ids, codigoCamp, codigoBanner }) {

        return new Promise((resolve) => {
            const req = jquery.post(this._urlAudit,
                {
                    auTipAudit: 'clic',
                    auSubTipAudit: tipoAuditoria,
                    auCodEmp: codigoEmpresa,
                    auCodOfi: codigoOficina,
                    auIdSoporte: ids,
                    auCodCamp: codigoCamp,
                    auCodBanner: codigoBanner
                });

            req.done(() => {
                resolve();
            });
        });
       


    }

}

export default AuditRepository;